import graphql from './graphql';

const query = /* GraphQL */ `
  query Course_list_developmentPlan($name: String, $terminal: String, $limit: Int, $offset: Int!) {
    Course_list_developmentPlan(name: $name, terminal: $terminal, limit: $limit, offset: $offset) {
      rows {
        id
        name
        totalUsers
        completedUsers
        CourseCategory {
          name
        }
        Priority {
          name
        }
      }
      count
    }
  }
`;

const CourseListDevelopmenPlan = async attributes =>
  graphql(query, attributes)
    .then(data => data.Course_list_developmentPlan)
    .catch(err => err);

export default CourseListDevelopmenPlan;
